var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',[_c('b-col',[_c('base-input',{attrs:{"type":"text","placeholder":_vm.placeHolder},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }